import React from "react";
import { Box, Container, Typography, Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const Footer = () => {
  const theme = useTheme();
  const { lang } = useLang();
  const { footer } = locales;
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        width: "100%",
        bgcolor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      }}
    >
      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          mx: "auto",
          px: { xs: 2, sm: 4 },
          py: { xs: 3, md: 4 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 1.5, sm: 3 },
          }}
        >
          <MuiLink
            href="/about"
            sx={{ color: "inherit", textDecoration: "none", fontSize: "1rem" }}
          >
            {footer.about?.[lang]}
          </MuiLink>
          <MuiLink
            href="/terms"
            sx={{ color: "inherit", textDecoration: "none", fontSize: "1rem" }}
          >
            {footer.terms?.[lang]}
          </MuiLink>
          <MuiLink
            href="/privacy"
            sx={{ color: "inherit", textDecoration: "none", fontSize: "1rem" }}
          >
            {footer.privacy?.[lang]}
          </MuiLink>
          <MuiLink
            href="/contact"
            sx={{ color: "inherit", textDecoration: "none", fontSize: "1rem" }}
          >
            {footer.contact?.[lang]}
          </MuiLink>
        </Box>

        <Typography sx={{ fontSize: { xs: ".95rem", md: "1rem" } }}>
          {footer.brand?.[lang]}
        </Typography>
        <Typography sx={{ fontSize: { xs: ".85rem", md: ".95rem" } }}>
          {footer.all_rights_reserved?.[lang]?.replace("{year}", currentYear)}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
